(function () {
  angular
    .module("akitabox.desktop.asset.detail")
    .controller(
      "AssetClosedWorkOrdersTabController",
      AssetClosedWorkOrdersTabController
    );

  /* @ngInject */
  function AssetClosedWorkOrdersTabController(
    // Constants
    WORK_ORDER_STATUS_CLOSED,
    // Resolve
    building,
    asset,
    // Dialogs
    ExportDialog,
    // Services
    OrganizationService,
    WorkOrderService,
    WorkOrdersBFFService,
    ToastService
  ) {
    var self = this;

    // Attributes
    self.building = building;
    self.asset = asset;
    self.status = WORK_ORDER_STATUS_CLOSED;
    self.workOrders = null;
    self.createOptions = getCreateOptions();
    self.permissions = getDefaultPermissions();
    self.fabActions = getFabActions();
    self.organization = OrganizationService.getCurrent();

    // Functions
    self.fetchWorkOrders = fetchWorkOrders;
    self.fetchAllWorkOrders = fetchAllWorkOrders;

    // ------------------------
    //   Public Functions
    // ------------------------

    function fetchWorkOrders(skip, limit) {
      var params = {
        status: self.status,
        asset: asset._id,
        skip: skip,
        limit: limit,
      };

      return WorkOrdersBFFService.getByBuilding(
        self.organization._id,
        self.building._id,
        params
      )
        .then(function (workOrders) {
          if (angular.isArray(self.workOrders)) {
            self.workOrders = self.workOrders.concat(workOrders);
          } else {
            self.workOrders = workOrders;
          }
          return workOrders.length;
        })
        .catch(ToastService.showError);
    }

    function fetchAllWorkOrders(limit) {
      var params = {
        status: self.status,
        asset: asset._id,
        skip: 0,
        limit: limit,
      };

      return WorkOrdersBFFService.getByBuilding(
        self.organization._id,
        self.building._id,
        params
      )
        .then(function (workOrders) {
          self.workOrders = workOrders;
          return workOrders.length;
        })
        .catch(ToastService.showError);
    }

    // ------------------------
    //   Private Functions
    // ------------------------

    function getFabActions() {
      return [
        {
          icon: "get_app",
          label: "Export",
          action: exportWorkOrders,
        },
      ];
    }

    function exportWorkOrders() {
      var locals = {
        route: WorkOrderService.buildListRoute(building._id),
        filters: {
          status: self.status,
          asset: asset._id,
        },
      };
      ExportDialog.show({ locals: locals }).catch(ToastService.showError);
    }

    function getCreateOptions() {
      return {
        locals: {
          floors: asset.level ? [asset.level] : null,
          rooms: asset.room ? [asset.room] : null,
          assets: [asset],
        },
      };
    }

    function getDefaultPermissions() {
      return {
        canAddWorkOrder: false,
      };
    }
  }
})();
